import { canv } from "@/canv/global";
import { tableWidget } from "@/elements/table/table";
import { Group } from "@/group";
import { toolBase } from "@/tools/toolBase";
import { selectionManager } from "../cursorTool";

export class tableTool extends toolBase {
    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.25C3 5.38805 3.34241 4.5614 3.9519 3.9519C4.5614 3.34241 5.38805 3 6.25 3H17.75C18.612 3 19.4386 3.34241 20.0481 3.9519C20.6576 4.5614 21 5.38805 21 6.25V17.75C21 18.612 20.6576 19.4386 20.0481 20.0481C19.4386 20.6576 18.612 21 17.75 21H6.25C5.38805 21 4.5614 20.6576 3.9519 20.0481C3.34241 19.4386 3 18.612 3 17.75V6.25ZM6.25 4.5C5.78587 4.5 5.34075 4.68437 5.01256 5.01256C4.68437 5.34075 4.5 5.78587 4.5 6.25V11.25H11.25V4.5H6.25ZM11.25 12.75H4.5V17.75C4.5 18.716 5.284 19.5 6.25 19.5H11.25V12.75ZM12.75 12.75V19.5H17.75C18.2141 19.5 18.6592 19.3156 18.9874 18.9874C19.3156 18.6592 19.5 18.2141 19.5 17.75V12.75H12.75ZM19.5 11.25V6.25C19.5 5.78587 19.3156 5.34075 18.9874 5.01256C18.6592 4.68437 18.2141 4.5 17.75 4.5H12.75V11.25H19.5Z" fill="#2C2D32"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Таблица";
    }

    select() {
        super.select();
    }

    unselect() {
        super.unselect();
        this.ghost = null;
        this.isResize = false;
    }

    getTableWrapper(isGhost = false) {
        const pt = canv.actionManager.getActionPoint();

        const creationStartX = pt.x;
        const creationStartY = pt.y;

        const newElement = new tableWidget(creationStartX, creationStartY);

        const newGroup = new Group(true, isGhost);
        newElement.setParent(newGroup);

        return newGroup;
    }

    resizeGhost() {
        if (!this.ghost) {
            return;
        }

        const pt = canv.actionManager.getActionPoint();

        const tableWidget = this.ghost.onlyChild() as tableWidget;
        const tableWidgetLastRow = tableWidget.rows[tableWidget.rows.length - 1];
        const tableWidgetLastRowLastCell =
            tableWidgetLastRow.cells[tableWidgetLastRow.cells.length - 1];

        if (pt.x >= this.ghost.startX + this.ghost.width) {
            tableWidget.addColumn(false);
        } else if (pt.x < tableWidgetLastRowLastCell.startX) {
            if (tableWidgetLastRow.cells.length > 2) {
                tableWidget.removeLastColumn();
            }
        }

        if (pt.y >= this.ghost.startY + this.ghost.height) {
            tableWidget.addRow(false);
        } else if (pt.y < tableWidgetLastRowLastCell.startY) {
            if (tableWidget.rows.length > 2) {
                tableWidget.removeLastRow();
            }
        }
    }

    TryAction(type: string) {
        // если сразу сделать mouseup не дождавшись mousemove, ghost тоже должен быть
        if (this.ghost == null) {
            this.ghost = this.getTableWrapper(true);
        }

        if (type === "mouseup") {
            canv.canvasController.addGroup(this.ghost);

            canv.eventManager.openRecord();
            canv.eventManager.createBuildEvent("create", this.ghost);
            canv.eventManager.closeRecord();

            selectionManager.setSelected([this.ghost]);
        } else if (type === "mousemove") {
            if (this.isResize) {
                this.resizeGhost();
            } else {
                if (canv.actionManager.isMouseDown()) {
                    if (canv.actionManager.getClickMoveValue() > 3) {
                        this.isResize = true;
                    }
                } else {
                    const pt = canv.actionManager.getActionPoint();

                    const translateX = pt.x - this.ghost.startX;
                    const translateY = pt.y - this.ghost.startY;
                    this.ghost.translateGroup(translateX, translateY);
                }
            }
        }

        canv.redraw();
    }

    draw() {
        if (!this.ghost) {
            return;
        }

        this.ghost.draw();

        // рисуем подсказку

        const titleInfo = this.getTitleInfo();

        if (!titleInfo) {
            return;
        }

        canv.ctx.font = titleInfo["font"];
        canv.ctx.fillStyle = "grey";
        canv.ctx.fillText(titleInfo["text"], titleInfo["titleX"], titleInfo["titleY"]);
    }

    getTitleInfo() {
        if (!this.ghost) {
            return;
        }

        const fontSize = canv.actionManager.getZoomConstant(13);
        const margin = canv.actionManager.getZoomConstant(9);
        const text = "Кликните и двигайте курсор, чтобы задать размер";

        canv.ctx.font = `${fontSize.toString()}px Spoof`;
        const metrics = canv.ctx.measureText(text);
        const titleHeight = metrics.actualBoundingBoxAscent; //+ metrics.actualBoundingBoxDescent;
        const titleWidth = metrics.width;

        const titleY = this.ghost.startY + this.ghost.height + margin + titleHeight;

        return {
            font: canv.ctx.font,
            text: text,
            titleY: titleY,
            titleX: this.ghost.startX + this.ghost.width / 2 - titleWidth / 2,
        };
    }

    isResize = false;
    ghost: Group | null = null;
    name = "tableTool";
}
